export default __webpack_public_path__ + "static/media/miguel-lopes-18.ec6798e4.jpg";